import { useState } from 'react'

const THEME_KEY = 'hkmbc.theme'

function currentTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(currentTheme)
  const dark = theme === 'dark'
  const label = dark ? '改為淺色' : '改為深色'

  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark'
    document.documentElement.dataset.theme = next
    localStorage.setItem(THEME_KEY, next)
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.setAttribute('content', next === 'dark' ? '#161210' : '#f6f3f2')
    setTheme(next)
  }

  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={label}
      title={label}
      onClick={toggle}
    >
      {dark ? (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4" fill="currentColor" />
          <path
            d="M12 2.5v2.2M12 19.3v2.2M4.8 4.8l1.5 1.5M17.7 17.7l1.5 1.5M2.5 12h2.2M19.3 12h2.2M4.8 19.2l1.5-1.5M17.7 6.3l1.5-1.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M15.2 3.2a8.6 8.6 0 1 0 5.6 14.7A8.2 8.2 0 0 1 15.2 3.2z"
          />
        </svg>
      )}
    </button>
  )
}
